import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export function useURLState(key, defaultValue = null) {
  const [searchParams, setSearchParams] = useSearchParams()

  const value = useMemo(() => {
    const paramValue = searchParams.get(key)
    if (paramValue === null || paramValue === undefined || paramValue === '') {
      return defaultValue
    }
    return paramValue
  }, [searchParams, key, defaultValue])

  const setValue = useCallback(
    (nextValue, options = { replace: true }) => {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev)
        if (nextValue === null || nextValue === undefined || nextValue === '') {
          params.delete(key)
        } else {
          params.set(key, nextValue)
        }
        return params
      }, options)
    },
    [key, setSearchParams]
  )

  return [value, setValue]
}
